import { Link } from 'react-router-dom';
import { siteCategories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h4 className="font-heading text-lg text-foreground-950 mb-3">
              Kakobuy<span className="text-primary-500">Spreadsheet</span> Polska
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Najlepsza baza produktów i linków zakupowych dla polskich klientów.
              Znajdź najlepsze produkty z Chin szybciej dzięki naszym listom.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-950 mb-3">Kategorie</h4>
            <div className="grid grid-cols-2 gap-1">
              {siteCategories.slice(0, 8).map((cat) => (
                <a
                  key={cat.nameEn}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap py-1"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-950 mb-3">Linki</h4>
            <div className="flex flex-col gap-1">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap py-1">
                Strona główna
              </Link>
              <Link to="/artykul/kakobuy-spreadsheet-przewodnik" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap py-1">
                Przewodnik Kakobuy Spreadsheet
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap py-1"
              >
                Kakobuy Spreadsheet Oficjalna Strona
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Kakobuy Spreadsheet Polska. Wszelkie prawa zastrzeżone.
          </p>
          <p className="text-xs text-foreground-400">
            Ta strona nie jest oficjalnym sklepem Kakobuy. Pełni funkcję informacyjną.
          </p>
        </div>
      </div>
    </footer>
  );
}